import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'
import 'rxjs/add/observable/throw';
import { Constants } from '../../shared/Constants';

@Injectable()
export class LoginService {
  public url: string;
  public dato: any;
  public name: any = 'sin nombre';
  constructor(public _http: Http) {
    this.name = this.name;
  }
  setName(nombre: string) {
    this.name = nombre;
  }
  getPDato() {
    return this.name;
  }
  getProducto(id) {
    return this._http.get(Constants.URL_BACKEND  + 'producto/' + id).map(res => res.json());
  }
  addUser(id_token) {
    const id = 'id_token=' + id_token;
    const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    headers.append('Access-Control-Allow-Headers', 'Content-Type');
    headers.append('Access-Control-Allow-Methods', 'GET');
    headers.append('Access-Control-Allow-Origin', '*');
    return this._http.post(Constants.URL_BACKEND  + 'GoogleLogin', id, { headers: headers })
      .map(res => res.json());
  }
  addUserFacebook(id_token) {
    const id = 'id_token=' + id_token;
    const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    headers.append('Access-Control-Allow-Headers', 'Content-Type');
    headers.append('Access-Control-Allow-Methods', 'GET');
    headers.append('Access-Control-Allow-Origin', '*');
    return this._http.post(Constants.URL_BACKEND  + 'FacebookLogin', id, { headers: headers })
      .map(res => res.json());
  }
  normalLogin(token: any) {
    return this._http.post(Constants.URL_BACKEND + '/HS_Autenticar', { jwt: token })
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().message || 'Server error'));
  }
  googleLogin(tokenGoogle: any){
    return this._http.post(Constants.URL_BACKEND + '/GoogleLoginAdage', { jwt: tokenGoogle })
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().message || 'Server error'));
  }
}


// WEBPACK FOOTER //
// ./src/app/public/login/login.service.ts